import PropTypes from 'prop-types';
import { Center, Box, Image } from '@chakra-ui/react';

function CourseImage({ name, image, category, ...rest }) {
  const baseFileUrl = process.env.REACT_APP_FILE_URL;

  return (
    <Box aspectRatio={16 / 9} w="100%">
      <Image
        {...rest}
        fallback={
          <Box
            pos="relative"
            w="100%"
            h="100%"
            bg="black"
            _before={{
              content: '""',
              bgImage: require('assets/default-course.jpg'),
              bgSize: 'cover',
              pos: 'absolute',
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
              opacity: 0.2,
            }}
          >
            <Center h="100%" w="100%">
              <Image
                src={`${baseFileUrl}${category?.thumbnailPath}`}
                maxW="80%"
                maxH="80%"
                fallbackSrc={require('assets/course-thumbnails/skillquest-thumbs_ic-essentials-08.png')}
                alt={name}
                objectFit="contain"
              />
            </Center>
          </Box>
        }
        src={`${baseFileUrl}${image}`}
        alt={name}
        w="100%"
        h="100%"
        objectFit="cover"
      />
    </Box>
  );
}

CourseImage.defaultProps = {
  name: null,
  image: null,
  category: null,
};

CourseImage.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  category: PropTypes.object,
};

export default CourseImage;
